module.exports = __webpack_public_path__ + "static/media/reedMonoN909.15d6f5db.ico";